import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './floating-button.scss';

const propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string.isRequired,
  content: PropTypes.node,
};

const FloatingButton = ({
  onClick,
  icon = 'far fa-qrcode',
  content,
}) => (
  <div
    className={classNames(
      styles.container,
    )}
  >
    <div
      role="button"
      tabIndex="0"
      onClick={onClick}
      className={styles.scan}
    >
      <i className={icon} />
      {' '}
      {content}
    </div>
  </div>
);

FloatingButton.propTypes = propTypes;

export default FloatingButton;
